import React from "react";
import { Link, useHistory } from "react-router-dom";
import { Navbar, Nav } from "react-bootstrap";

import "../../../assets/css/Common.css";
import "./TopNavigation.css";
import * as Constants from "../../../constants/Constants";

export const publicNavList = [
  {
    navName: "Document library",
    navLink: "/document-library",
    navLinkIdentifier: "documentLibrary",
    navId: "document-library",
  },
];

const TopNavigation = (props) => {
  const history = useHistory();
  const highlightMenuItem = (navId) => {
    const param = history.location.pathname.split("/");
    const style = {
      fontWeight: 600,
      fontSize: 14,
    };
    if (param.includes(navId)) {
      return style;
    }
    return {};
  };
  const verifyMenuItemAccess = (navId) => {
    if (navId === "document-library") {
      return Constants.ENABLE_DOC_LIBRARY === "D" ? false : true;
    }
    return true;
  };

  return (
    <div>
      <Navbar bg="light" expand="lg" collapseOnSelect>
        <Nav className="mr-auto my-2 my-lg-0">
          {publicNavList.map((nav, i) => {
            if (verifyMenuItemAccess(nav.navId)) {
              let menusDisable =
                typeof props[nav.navId] !== "undefined" &&
                props[nav.navId]?.menusDisable
                  ? props[nav.navId].menusDisable
                  : false;

              return (
                <Link
                  id={nav.navId}
                  to={nav.navLink}
                  style={{
                    marginRight: 30,
                    pointerEvents: menusDisable,
                    ...highlightMenuItem(nav.navId),
                  }}
                  key={`${i}-${nav.navId}`}
                >
                  {nav.navName}
                </Link>
              );
            }
          })}
        </Nav>
      </Navbar>
    </div>
  );
};

export default TopNavigation;
